import React from "react";
import HeaderBottomOne from "../common/header/HeaderBottomOne";
import HeroStyleOne from "../components/hero/HeroStyleOne";
import HomeOneService from "../components/home1/HomeOneService";
import ProjectStyleOne from "../components/project/ProjectStyleOne";
import WhyChoseUsOne from "../components/why-choose-us/WhyChoseUsOne";
import InstagramPreview from "../components/instagram/InstagramPreview";
import FooterOne from "../common/footer/FooterOne";
const HomeDefault = () => {
    return (
        <>
            {/*<HeaderTop />*/}
            <HeaderBottomOne />
            <HeroStyleOne />
            {/* <ServiceStyleOne /> */}
            {/* <HomeOneAbout /> */}
            <ProjectStyleOne />
            {/* <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br> */}
            {/* <FunFact />
            <br></br>
            <br></br>
            <br></br> */}

            <WhyChoseUsOne />

            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <HomeOneService />
            <InstagramPreview />
            {/* <TestimonialStyleOne /> */}
            {/* <HomeOneBookAppointment /> */}
            {/* <HowItWorkOne /> */}
            {/* <BlogStyleOne /> */}
            <FooterOne />
        </>
    )
}

export default HomeDefault;